import type Tool from './Tool';
import { type IToolEnabledInput } from './Tool';

function DisableWhileUploadingBehavior(Base: typeof Tool): typeof Tool {
  return class DisableWhileUploading extends Base {
    static disabledMessage =
      "This image is being uploaded, you won't be able to copy/cut it until the process is complete.";

    static enabled({ controller, selection }: IToolEnabledInput) {
      const enabled = super.enabled({ controller, selection });
      if (!enabled || !controller.hasActiveUploads) return enabled;

      const uploadingImageSelected = selection?.getObjects().find(element => {
        return controller.state.activeAttachmentUploads.includes(element.id);
      });

      return !uploadingImageSelected;
    }
  };
}

export default DisableWhileUploadingBehavior;
